import React from "react";
import { useSelector } from "react-redux";
import SpinnerContainerOverlay from "../Spinner/SpinnerContainerOverlay";

const LoadingWrapper = ({ children }) => {
  const spinnerActions = useSelector(
    (state) => state.systemReducer.spinnerActions
  );

  return (
    <>
      {spinnerActions && <SpinnerContainerOverlay />}
      {children}
    </>
  );
};

export default LoadingWrapper;
